if (!customElements.get("quick-add-modal")) {
    customElements.define(
        "quick-add-modal",
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide() {
                super.hide();
            }

            show(opener) {
                // 1. Damos feedback visual al usuario (estado de carga)
                opener.setAttribute("aria-disabled", true);
                opener.classList.add("loading");

                if (opener.querySelector(".loading-overlay__spinner")) {
                    opener.querySelector(".loading-overlay__spinner").classList.remove("hidden");
                }

                // 2. Obtenemos la URL y redirigimos inmediatamente
                const productUrl = opener.getAttribute("data-product-url");
                if (productUrl) {
                    window.location.href = productUrl;
                }
            }
        }
    );
}